import { useEffect, useState } from "react";
import axios from "axios";

export default function AccountsPage() {
  const [accounts, setAccounts] = useState([]);
  const [type, setType] = useState("personal");
  const token = localStorage.getItem("token");

  const fetchAccounts = async () => {
    try {
      const res = await axios.get("http://localhost:4000/api/accounts", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setAccounts(res.data.accounts);
    } catch (err) {
      console.log(err.response?.data || err.message);
    }
  };

  const createAccount = async () => {
    try {
      await axios.post(
        "http://localhost:4000/api/accounts",
        {
          type: type
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      fetchAccounts();
    } catch (err) {
      console.log(err.response?.data || err.message);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  return (
    <div style={{ padding: 40 }}>
      <h2>Accounts</h2>

      <div>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="personal">Personal</option>
          <option value="investment">Investment</option>
          <option value="business">Business</option>
        </select>

        <button onClick={createAccount}>Create Account</button>
      </div>

      <hr />

      {accounts.length === 0 ? (
        <p>No accounts found</p>
      ) : (
        accounts.map((acc) => (
          <div key={acc._id}>
            <p>Type: {acc.type}</p>
            <p>Balance: {acc.balance}</p>
          </div>
        ))
      )}
    </div>
  );
}